'use client';

import { ComponentProps, ReactNode } from 'react';
import { Link } from '@/i18n/navigation';
import { tracker } from '@/utility/tracking/tracker';

type RelatedTagLinkProps = Omit<ComponentProps<typeof Link>, 'href'> & {
  href: ComponentProps<typeof Link>['href'];
  tagName: string;
  children: ReactNode;
};

export const RelatedTagLink = ({
  href,
  tagName,
  children,
  onClick,
  ...rest
}: RelatedTagLinkProps) => {
  return (
    <Link
      href={href}
      {...rest}
      onClick={(e) => {
        onClick?.(e);
        tracker.trackFeature({
          featureUsed: 'tag-search',
          detail: tagName,
        });
      }}
    >
      {children}
    </Link>
  );
};
